export default __webpack_public_path__ + "static/media/supported-payment-methods.d5d47937.png";